module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "flex-content"
  }, [(_vm.balanceList.length > 0) ? _c('group', _vm._l((_vm.balanceList), function(log) {
    return _c('cell', {
      key: log.id,
      attrs: {
        "link": '/uc/orderDetail/' + log.order_id,
        "disabled": log.desc === "用户提现" || log.order_id === 0
      }
    }, [_c('span', {
      staticStyle: {
        "color": "#0bb20c",
        "padding": "5px 0"
      },
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(log.desc))]), _vm._v(" "), _c('div', {
      staticClass: "desc",
      attrs: {
        "slot": "inline-desc"
      },
      slot: "inline-desc"
    }, [(log.desc !== '用户提现' && log.order_id > 0) ? _c('div', [_vm._v("订单ID：" + _vm._s(log.order_id))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "color": "grey",
        "padding": "0px 0",
        "opacity": "0.5"
      }
    }, [_vm._v(_vm._s(log.time))])]), _vm._v(" "), _c('div', {
      attrs: {
        "slot": ""
      },
      slot: "default"
    }, [_c('div', [_c('span', {
      staticStyle: {
        "color": "red",
        "font-size": "120%"
      }
    }, [_vm._v(_vm._s(log.amount))])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "grey",
        "font-size": "90%",
        "opacity": "0.8"
      }
    }, [_vm._v(_vm._s(log.remain_amount))])])])
  })) : _vm._e(), _vm._v(" "), _c('infinite-loading', {
    on: {
      "infinite": _vm.infiniteHandler
    }
  }, [_c('divider', {
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  }, [_vm._v("没有更多数据了")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30af7956"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/uc/Balance.vue
// module id = 665
// module chunks = 0